import { motion } from "framer-motion";
import { IMG } from "./constants";

export default function Gallery({ t }) {
  const items = [
    { key: "platos-bodegon", src: IMG.g1, span: "lg:col-span-2 lg:row-span-2", h: "h-[300px] lg:h-full", alt: "Pared platos de bodegón" },
    { key: "vermouth-bar", src: IMG.g2, span: "", h: "h-[200px] lg:h-[240px]", alt: "Vermouth bar y mantel cuadrillé" },
    { key: "berenjenas", src: IMG.g3, span: "", h: "h-[200px] lg:h-[240px]", alt: "Berenjenas en escabeche" },
    { key: "sorrentinos", src: IMG.g4, span: "lg:col-span-2", h: "h-[200px] lg:h-[240px]", alt: "Sorrentinos de jamón y queso" },
    { key: "bar", src: IMG.g5, span: "", h: "h-[200px] lg:h-[240px]", alt: "Bar Bodegón Núñez" },
    { key: "salon", src: IMG.g6, span: "", h: "h-[200px] lg:h-[240px]", alt: "Salón principal" },
  ];

  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="relative py-24 md:py-32 bg-bn-secondary text-bn-bg overflow-hidden"
    >
      <div className="absolute top-0 left-0 right-0 h-2 bg-checkered-strong" />
      <div className="absolute bottom-0 left-0 right-0 h-2 bg-checkered-strong" />

      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="mb-12 md:mb-16 max-w-3xl">
          <p className="font-body text-bn-accent text-sm uppercase tracking-[0.3em] mb-4">
            — {t.gallery.kicker}
          </p>
          <h2
            className="font-display text-bn-bg text-4xl md:text-5xl lg:text-6xl leading-[1.05] mb-4"
            data-testid="gallery-title"
          >
            {t.gallery.title}
          </h2>
          <p className="font-body text-bn-bg/70 text-base md:text-lg max-w-xl">
            {t.gallery.subtitle}
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4 lg:auto-rows-[240px]">
          {items.map((it, i) => (
            <motion.div
              key={it.key}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className={`overflow-hidden group relative ${it.span} ${it.h}`}
              data-testid={`gallery-item-${it.key}`}
            >
              <img
                src={it.src}
                alt={it.alt}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
